import React, { Children, isValidElement } from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  Accordion as ChakraAccordion,
  Box,
  forwardRef,
} from '@chakra-ui/react';

import { DescendantsVariantProvider } from '../../../providers/descendants-variant-provider';
import { AccordionItem } from '../accordion-item';
import { AccordionProps } from './types';

const Accordion = forwardRef<AccordionProps, 'div'>(
  ({ children, variant, ...props }, ref) => {
    const accordionItems = Children.toArray(children).filter(
      (child) => isValidElement(child) && child.type === AccordionItem
    );

    return (
      <DescendantsVariantProvider value={{ variant }}>
        <ChakraAccordion ref={ref} variant={variant} {...props}>
          <Box>
            {accordionItems.map((item, index) => (
              <Box key={index}>
                <Box>{item}</Box>
              </Box>
            ))}
          </Box>
        </ChakraAccordion>
      </DescendantsVariantProvider>
    );
  }
);
export { Accordion };
